export default "__VITE_ASSET__DSO5UB4p__"